import React, { useEffect, useMemo } from 'react';
import { Button } from '@material-ui/core';
import { Alert, AlertTitle } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useHistory, useLocation } from 'react-router-dom';
import { useMeContext } from '~/modules/me/useMeContext';
import { useDialogState, useIsBreakpointDown } from '~/modules/common/hooks';
import { USER_ACCESS_ROLE } from '~/modules/common/enums';
import { DelaStarIcon } from '~/modules/common/components/Icons';
import useRefetchAttachmentInfo from '../UserResumeParsingProcessedAlert/useRefetchAttachmentInfo';
import useStyles, {
  useIconStyles
} from '../UserResumeParsingProcessedAlert/useStyles';
import useProjectSOWParsingSubscription from './useProjectSOWParsingSubscription';

const ProjectSOWParsingProcessedAlert = () => {
  const classes = useStyles();
  const iconClasses = useIconStyles();
  const { id: userUri, userAccessRoles, featureFlags } = useMeContext();
  const { refetchAttachmentInfo } = useRefetchAttachmentInfo();
  const isMobile = useIsBreakpointDown('sm');
  const {
    slug: projectSlug,
    displayText: projectDisplayText
  } = useProjectSOWParsingSubscription({
    userUri,
    skipSubscription:
      !featureFlags.isPsaPraaResourceMatchingEnabled ||
      isMobile ||
      !userAccessRoles.some(
        r =>
          r === USER_ACCESS_ROLE.PROJECT_MANAGER ||
          r === USER_ACCESS_ROLE.CLIENT_MANAGER ||
          r === USER_ACCESS_ROLE.PROGRAM_MANAGER ||
          r === USER_ACCESS_ROLE.PROJECT_ADMIN
      )
  });

  const { open, closeDialog, openDialog } = useDialogState();

  const values = useMemo(
    () => ({
      projectName: projectDisplayText
    }),
    [projectDisplayText]
  );

  useEffect(() => {
    if (projectSlug) {
      openDialog();
      refetchAttachmentInfo();
    }
  }, [refetchAttachmentInfo, openDialog, projectSlug]);

  const history = useHistory();
  const location = useLocation();

  const viewRequestsLink = `/projects/${projectSlug}/resourcingplan?edit=true`;

  const handleViewRequests = () => {
    if (location.pathname === viewRequestsLink) {
      window.location.reload();
    } else {
      history.push(viewRequestsLink);
    }
  };

  const iconComponent = <DelaStarIcon role="img" classes={iconClasses} />;

  if (open) {
    return (
      <Alert
        severity="info"
        onClose={closeDialog}
        classes={classes}
        icon={iconComponent}
      >
        <AlertTitle>
          <FormattedMessage id="projectSOWParsingProcessedAlert.title" />
        </AlertTitle>
        <div className={classes.container}>
          <FormattedMessage
            id="projectSOWParsingProcessedAlert.description"
            values={values}
          />
          <Button
            onClick={handleViewRequests}
            color="primary"
            className={classes.button}
          >
            <FormattedMessage id="projectSOWParsingProcessedAlert.viewRequests" />
          </Button>
        </div>
      </Alert>
    );
  }

  return <></>;
};

export default ProjectSOWParsingProcessedAlert;
